import { CommonModule } from "@angular/common";
import { Component, OnDestroy, signal } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FUNCTION_RESULT_STATUS } from "@nova/common-interfaces";
import { ICustomerOverview } from "@rfm/shared-interfaces";
import { BlockUIModule } from "ng-block-ui";
import {
  ConfirmationService,
  MessageService
} from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ToastModule } from "primeng/toast";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { CommonComponent } from "../../../../lib/components/index.mjs";
import { PaymentMethodsComponent } from "../../../shared/components/financial/payment-methods/payment-methods.component";
import { AuthService } from "../../../shared/services/auth/auth.service";
import { CustomerService } from "../../../shared/services/customers/customers.service.mjs";
import { LatestInvoicePaymentComponent } from './latest-invoice-payment/latest-invoice-payment.component';
import { PaymentHistoryComponent } from './payment-history/payment-history.component';
 
@Component({
  selector: "app-make-payment",
  standalone: true,
  imports: [
    CommonModule,
    BlockUIModule,
    ConfirmDialogModule,
    ToastModule,
    ButtonModule,
    PaymentMethodsComponent,
    DialogModule,
    ToggleSwitchModule,
    LatestInvoicePaymentComponent,
    PaymentHistoryComponent
  ],
  providers: [MessageService, ConfirmationService, DialogService],
  templateUrl: "./make-payment.component.html",
  styleUrl: "./make-payment.component.scss",
})
export class MakePaymentComponent extends CommonComponent implements OnDestroy {
  customer_overview = signal<ICustomerOverview | undefined>(undefined);
  paidInFull = false;
  ref: DynamicDialogRef | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private customerService: CustomerService,
    private authService: AuthService
  ) {
    super();
    this.isLoading(true);
  }

  ngOnInit(): void {
    this.handleData(false);
  }

  handleData(forceRefresh: boolean) {
    this.isLoading(true);

    this.authService.user$.subscribe(async (user) => {

      let uid = user!.uid;
      
      if (this.activatedRoute.snapshot.params['id'])
      {
        uid = this.activatedRoute.snapshot.params['id'];
      }
      await this.customerService
        .getOverview(uid, forceRefresh)
        .then(async (x) => {
          if (x.status === FUNCTION_RESULT_STATUS.SUCCESS) {
            console.log("CUSTOMEROVERVIEW", x);
            this.customer_overview.set(x.data);

            if (this.customer_overview()?.balances?.data.reduce((accumulator: any, current: any) => accumulator + current.current_balance, 0) === 0) {
              this.paidInFull = true;
            }
          }
        })
        .finally(() => {
          this.isLoading(false);
        });
    });
  }

  autopayToggled() {}

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }
}
